import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

export function httpInterceptor(req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {

  if (req.url.includes('/public/')) {
    return next(req);
  }

  const clonedRequest = req.clone({
    withCredentials: true
  });
  
  return next(clonedRequest);
}
